import { Component, OnInit, Inject, PLATFORM_ID, OnDestroy, NgZone, Renderer2, RendererFactory2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// import { LanguagesService } from './services/languages.service';
import { Router, NavigationEnd } from '@angular/router';
// import { UserTokenService } from './services/user-token.service';
// import { UserService } from './user/user.service';
import { EnvService } from './services/env.service';
import { NgcCookieConsentService, NgcInitializingEvent, NgcInitializationErrorEvent, NgcStatusChangeEvent, NgcNoCookieLawEvent } from 'ngx-cookieconsent';
import { Subscription } from 'rxjs';
// import { ActivatedRoute } from '@angular/router';
import { SharedService } from './services/shared.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    currentUrl = '';
    title = 'rvhost_site';
    client_name_label: string;
    application_mode_label: string;
    subscriptionArr: Subscription[] = [];
    previewMode: string;
    headerHeight = 0;
    private headerResizeObserver?: ResizeObserver;
    showAppMode: boolean;
    isPlatformBrowser: boolean;
    loading_website = true;

    //keep refs to subscriptions to be able to unsubscribe later
    private popupOpenSubscription!: Subscription;
    private popupCloseSubscription!: Subscription;
    private initializingSubscription!: Subscription;
    private initializedSubscription!: Subscription;
    private initializationErrorSubscription!: Subscription;
    private statusChangeSubscription!: Subscription;
    private revokeChoiceSubscription!: Subscription;
    private noCookieLawSubscription!: Subscription;
  
    constructor(
        private translate: TranslateService,
        // private langService: LanguagesService,
        private router: Router,
        // private userService: UserService,
        // private userTokenService: UserTokenService,
        private EnvService: EnvService,
        @Inject(PLATFORM_ID) private platformId: any,
        private ccService: NgcCookieConsentService,
        // private route: ActivatedRoute,
        private sharedService: SharedService,
        private analyticsService:GoogleAnalyticsService,
        private ngZone: NgZone
    ) {
        this.isPlatformBrowser = isPlatformBrowser(this.platformId);
        // this.ccService.popupOpen$.subscribe(() => {
            setTimeout(() => {
                if (isPlatformBrowser(this.platformId)) {
                    const ccbuttons = document.querySelectorAll('.cc-btn');
                    ccbuttons.forEach((btn) => {
                        const element = btn as HTMLElement;
                        element.removeAttribute('aria-label');
                    });
                }
            }, 100);
        // });

        // this.renderer = rendererFactory.createRenderer(null, null);
        this.ccService.statusChange$.subscribe((event: NgcStatusChangeEvent) => {
            if (event.status === 'allow') {
                this.analyticsService.loadGTM();
            } else {
                this.analyticsService.removeGTM();
                // this.ccService.destroy();
            }
        });
        this.translate.getTranslation('en-GB');
        // this.userService.autoLogin().then((response: LoginResponse) => {
        //     if (response.status == 200) {
        //         this.userTokenService.setToken(response.token);
        //     } else {
        //         this.userTokenService.clear();
        //     }
        // });
        
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // setTimeout(() => {
                this.loading_website = false;

                // }, 100);

                if (isPlatformBrowser(this.platformId)) {
                    setTimeout(() => {
                        history.scrollRestoration = 'manual';  // Disable browser's automatic scroll restoration
                        window.scrollTo({ top: 0, behavior: 'instant' }); // Ensure immediate scrolling
                        this.observeHeaderHeight();
                    }, 0);
                }
            }
        });
    }
    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.analyticsService.checkConsentAndLoadGTM();
            if (typeof window.gtag === 'undefined') {
                window.gtag = function () {
                    window.dataLayer?.push(arguments);
                };
            }
            window.gtag('js', new Date());
            window.gtag('config', 'G-D7CD87HNWT');
            const defaultConsent = {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted',
            }
            // Set default consent
            window.gtag('consent', 'default', defaultConsent);
        }
        this.client_name_label = this.EnvService.clientName;
        this.application_mode_label = this.EnvService.applicationMode;
        this.showAppMode = this.EnvService.showAppMode;
        const routesubs = this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            if (isPlatformBrowser(this.platformId)) {
                window.scrollTo(0, 0);
            }
        });
        this.subscriptionArr.push(routesubs);
        // this.ccService.putCookie('consent_accepted', 'true');
        // subscribe to cookieconsent observables to react to main events
        this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(
            () => {
                // you can use this.ccService.getConfig() to do stuff...
            });

        this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
            () => {
                // you can use this.ccService.getConfig() to do stuff...
            });

        this.initializingSubscription = this.ccService.initializing$.subscribe(
            (event: NgcInitializingEvent) => {
                // the cookieconsent is initilializing... Not yet safe to call methods like `NgcCookieConsentService.hasAnswered()`
                console.log(`initializing: ${JSON.stringify(event)}`);
            });

        this.initializedSubscription = this.ccService.initialized$.subscribe(
            () => {
                // the cookieconsent has been successfully initialized.
                // It's now safe to use methods on NgcCookieConsentService that require it, like `hasAnswered()` for eg...
                console.log(`initialized: ${JSON.stringify(event)}`);
            });

        this.initializationErrorSubscription = this.ccService.initializationError$.subscribe(
            (event: NgcInitializationErrorEvent) => {
                // the cookieconsent has failed to initialize... 
                console.log(`initializationError: ${JSON.stringify(event.error?.message)}`);
            });

        this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
            (event: NgcStatusChangeEvent) => {
                // you can use this.ccService.getConfig() to do stuff...
            });

        this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
            () => {
                // you can use this.ccService.getConfig() to do stuff...
            });

        this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
            (event: NgcNoCookieLawEvent) => {
                // you can use this.ccService.getConfig() to do stuff...
            });
        this.sharedService.urlParams$.subscribe(params => {

            if (params) {
                this.previewMode = params.preview_mode
            }
        });
    }
    // The header is fixed-positioned, so it reserves no space in normal
    // flow. The preview banner needs the header's live height (it changes
    // across breakpoints as the nav wraps) to sit just below it without
    // overlapping, hence tracking it with a ResizeObserver instead of a
    // one-off measurement.
    private observeHeaderHeight(): void {
        if (this.headerResizeObserver) {
            return;
        }
        const header = document.getElementById('header');
        if (!header) {
            return;
        }
        this.headerHeight = header.offsetHeight;
        this.headerResizeObserver = new ResizeObserver((entries) => {
            const height = entries[0]?.contentRect.height ?? header.offsetHeight;
            this.ngZone.run(() => {
                this.headerHeight = Math.round(height);
            });
        });
        this.headerResizeObserver.observe(header);
    }

    skipToMain() {
        if (isPlatformBrowser(this.platformId)) {
            const element = document.querySelector('[role="main"]') as HTMLElement;
            element.setAttribute('tabindex', '-1') // You can set tabindex in HTML too than in JS
            element.focus()
        }


    }

    onActivate(event: any) {
        if (isPlatformBrowser(this.platformId)) {
            window.scroll(0, 0);
        }
    }
    ngOnDestroy() {
        this.subscriptionArr.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
        // unsubscribe to cookieconsent observables to prevent memory leaks
        this.popupOpenSubscription.unsubscribe();
        this.popupCloseSubscription.unsubscribe();
        this.initializingSubscription.unsubscribe();
        this.initializedSubscription.unsubscribe();
        this.initializationErrorSubscription.unsubscribe();
        this.statusChangeSubscription.unsubscribe();
        this.revokeChoiceSubscription.unsubscribe();
        this.noCookieLawSubscription.unsubscribe();
        this.headerResizeObserver?.disconnect();
    }
}
